import { useEffect, useState } from 'react';

import type { WikiGraph } from '@/api/client';
import { wikiApiClient } from '@/api/client';
import { useT } from '@/i18n/LocaleProvider';

type WikiGraphState = {
  data: WikiGraph | null;
  isLoading: boolean;
  error: string | null;
};

export function useWikiGraph(): WikiGraphState {
  const t = useT();
  const [data, setData] = useState<WikiGraph | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setError(null);

    wikiApiClient
      .getWikiGraph()
      .then((graph) => {
        if (!cancelled) {
          setData(graph);
          setIsLoading(false);
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : t('error_load_graph'));
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [t]);

  return { data, isLoading, error };
}
